import React, { useMemo, useState } from "react";
import GanttView, { pickDefaultZoom } from "../gantt/GanttView";
import { STAGE_LEGEND, buildStageViewRows } from "../gantt/stageRows";
import useOrgCalendar from "../gantt/useOrgCalendar";
import { buildGanttModel } from "../../utils/ganttModel";

export default function ProjectGanttChart({ project }) {
  const calendar = useOrgCalendar();
  const [zoom, setZoom] = useState(null);

  // "Now" is pinned per build so bars, the today line and overdue flags agree.
  const model = useMemo(() => {
    if (!calendar) return null;
    const now = new Date();
    return { ...buildGanttModel(project, calendar, now), now };
  }, [project, calendar]);

  const view = useMemo(
    () => (model ? buildStageViewRows(model) : null),
    [model],
  );

  if (!model) {
    return <div className="panel gantt-empty">Loading timeline...</div>;
  }
  if (!model.rows.length) {
    return (
      <div className="panel gantt-empty">
        This project's workflow has no stages to chart.
      </div>
    );
  }

  return (
    <GanttView
      rows={view.rows}
      dependencies={view.dependencies}
      min={model.min}
      max={model.max}
      now={model.now}
      calendar={calendar}
      zoom={zoom || pickDefaultZoom(model.min, model.max)}
      onZoomChange={setZoom}
      legend={STAGE_LEGEND}
      dimOnRowHover
    />
  );
}
